<template>
  <section class="footer-portugal-2020">
    <div class="footer-portugal-2020__items">
      <figure class="footer-portugal-2020__item">
        <figcaption>{{ $t('footer_10') }}</figcaption>
        <a
          target="_blank"
          href="https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
        >
          <picture>
            <img
              class="lazyload"
              data-src="/static/images/lisboa-2020.png"
            >
          </picture>
        </a>
      </figure>

      <figure class="footer-portugal-2020__item">
        <figcaption>&nbsp;</figcaption>
        <a
          target="_blank"
          href="https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
        >
          <picture>
            <img
              class="lazyload"
              data-src="/static/images/portugal-2020.png"
            >
          </picture>
        </a>
      </figure>

      <figure class="footer-portugal-2020__item">
        <figcaption>&nbsp;</figcaption>
        <a
          target="_blank"
          href="https://backoffice.blissapplications.com/media/dhcbmwrt/bliss-apoios.pdf"
        >
          <picture>
            <img
              class="lazyload"
              data-src="/static/images/uniao-europeia.png"
            >
          </picture>
        </a>
      </figure>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FooterPortugal2020'
};
</script>

<style lang="scss" src="@/assets/components/footer/footer-portugal-2020-view.scss"></style>



// WEBPACK FOOTER //
// footer-portugal-2020-view.vue